import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Container from 'gatsby-theme-core/src/components/container';
import Section from 'gatsby-theme-pdv/src/components/section';
import Wrapper from '../../../components/latest-blogs-wrapper';
import BlogPreview from '../../../components/latest-blogs-preview';

const LatestBlogs = ({
  rowOptions,
  title,
  className,
}) => {
  const { posts, blogPages } = useStaticQuery(graphql`
    query PdVLatestBlogsPostsQuery {
      posts: allWpPost(
        filter: { status: { eq: "publish" } },
        sort: { date: DESC },
        limit: 3
      ) {
        edges {
          node {
            id
            path: uri
            title
            excerpt
            date
            featuredImage {
              node {
                filename
                altText
                gatsbyImage(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  width: 390
                  cropFocus: ENTROPY
                )
              }
            }
          }
        }
      }

      blogPages: allStrapiPagesPages(
        filter: {
          template: {
            eq: "blogs"
          }
        }
      ) {
        nodes {
          id
          slug
        }
      }
    }
  `);

  if (posts.edges.length === 0) {
    return null;
  }

  const blogSlug = blogPages?.nodes[0]?.slug;

  return (
    <Section
      className={className}
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
    >
      <Container>
        <Title>
          <span>{title}</span>
          {blogSlug && (
            <StyledLink to={blogSlug}>Bekijk alle</StyledLink>
          )}
        </Title>
        <Wrapper>
          {posts.edges.map(({ node }) => (
            <BlogPreview key={node.id} {...node} />
          ))}
        </Wrapper>
      </Container>
    </Section>
  );
};

const Title = styled.h2`
  text-align: center;
  font-size: 1.75rem;
  margin: 0 0 2rem 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    justify-content: center;
  }
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.primaryColor};
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;

  &:before {
    content: '|';
    display: inline-block;
    padding: 0 .25rem;
  }
`;

export default LatestBlogs;
